import Pqp from "../../../../../3x1010/Pqp.js";
import Decision from "./Decision.js";

export default class StayPut extends Decision {
	constructor(initer) {
		super(initer);
		this.idto = -1;
	}

	init() {
		this.control.stop();
		let time = Pqp.rnd(StayPut.MAX_IDLE_TIME, StayPut.MIN_IDLE_TIME);
		this.idto = setTimeout(this.endStayPut.bind(this), time);

	}

	endStayPut() {
		this.accomplished();
	}

	destroy() {
		super.destroy();
		clearTimeout(this.idto)
	}

}

StayPut.MIN_IDLE_TIME = 1000;
StayPut.MAX_IDLE_TIME = 2000;